import wImage from "@/components/w-image.vue";

const wintacUI = {
  install:(vue)=>{
    vue.component("w-image", wImage)
  }
}
export default wintacUI;
